import * as React from 'react';
import {LayerType} from '../../../generated/api';

export interface LayerContextData {
    layerType?: LayerType;
}
export const LayerContext = React.createContext<LayerContextData>({});
